import { Box, CircularProgress, CircularProgressProps } from '@material-ui/core'
import cls from 'classnames'

import { useStyles } from './styles'

interface LoadingProps {
  className?: string
  color?: CircularProgressProps['color']
  size?: CircularProgressProps['size']
}
export default function Loading({ className, color, size }: LoadingProps) {
  const classes = useStyles()

  return (
    <Box className={cls(classes.main, className)}>
      <CircularProgress size={size || '4rem'} color={color} />
    </Box>
  )
}
